export const theme = {
    palette: {
        primary: {
            light: '#FF6861',
            main: '#E13028',
            dark: '#C31710'
        },
        secondary: {
            hover: '#ffb94263',
            light: '#FFB942',
            main: '#FEA500',
            dark: '#D99000'
        },
        text: {
            primary: '#E13028',
            secondary: '#FEA500',
            black: '#3D3D3D',
            white: '#FFFFFF',
            grayFullLight: '#F2F2F2',
            grayLight: '#B1B1B1',
            gray: '#5E5D5D',
        },
        icon: {
            primary: '#E13028',
            secondary: '#FEA500',
        }
    },
}